/* HOLY COW — Spend $100, get a free Wildara sunscreen (site-wide)
 *
 * Cart reconciler. Watches the cart and:
 *   - auto-adds 1 Wildara SPF when the non-gift subtotal reaches $100
 *   - auto-removes it if the cart drops back below $100
 *
 * The gift is priced to $0 by the native automatic "Buy X get Y" discount
 * (spend $100 -> 1 Wildara free). This script only ADD/REMOVEs the line item;
 * it never sets price. The discount must stay active or the gift would charge
 * full price.
 *
 * Gift lines are tagged with properties._holycow_spend_gift so the threshold
 * math excludes the gift itself (prevents it gating itself in/out).
 *
 * Pause the promo: deactivate the discount AND set PROMO_ACTIVE = false (then
 * re-push), or remove the script tag from theme.liquid.
 */
(function () {
  'use strict';

  var PROMO_ACTIVE = true;
  var GIFT_VARIANT_ID = 48081451614440; // Wildara Beef Tallow Sunscreen SPF 50
  var THRESHOLD_CENTS = 10000;           // $100 (pre-discount subtotal)
  var GIFT_PROP = '_holycow_spend_gift';

  if (!PROMO_ACTIVE || !GIFT_VARIANT_ID) return;

  var locked = false;

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function addGift() {
    var item = { id: GIFT_VARIANT_ID, quantity: 1, properties: {} };
    item.properties[GIFT_PROP] = 'spend100';
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
  }

  function removeGift(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    });
  }

  function isGiftLine(item) {
    var props = item.properties || {};
    return !!props[GIFT_PROP];
  }

  function reconcile() {
    if (locked) return;
    locked = true;

    return getCart()
      .then(function (cart) {
        var subtotal = 0;
        var giftLine = null;

        cart.items.forEach(function (item) {
          if (isGiftLine(item)) {
            giftLine = item;
          } else {
            subtotal += (item.final_line_price != null) ? item.final_line_price : item.line_price;
          }
        });

        var qualifies = subtotal >= THRESHOLD_CENTS;

        if (qualifies && !giftLine) {
          return addGift().then(broadcast);
        }
        if (!qualifies && giftLine) {
          return removeGift(giftLine).then(broadcast);
        }
      })
      .catch(function (err) {
        console.warn('[holycow-spend-gift]', err);
      })
      .then(function () {
        setTimeout(function () { locked = false; }, 300);
      });
  }

  function broadcast() {
    // 1) Theme's native drawer (if used): re-fetch sections + repaint.
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.refreshCartDrawer === 'function') {
      try { cd.refreshCartDrawer(); } catch (e) { /* theme drawer optional */ }
    }
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true, composed: true }));

    // 2) Zipify OCU drawer: it re-fetches the cart on these events. Firing them
    //    (with no preventEvent flag) makes Zipify's drawer repaint to show the
    //    auto-added sunscreen. Dispatch on both document and window to be safe.
    ['ocu:cart:update', 'ocu:cart:updated', 'ocu:product:added'].forEach(function (name) {
      var detail = { source: 'holycow-spend-gift' };
      try { document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true, composed: true })); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
    });
  }

  // Debounced reconcile so a burst of cart calls only triggers one pass.
  var pending = null;
  function scheduleReconcile() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { pending = null; reconcile(); }, 120);
  }

  // 1) Theme's own cart-refresh event (when it fires).
  document.addEventListener('cart-drawer:refresh', scheduleReconcile);

  // 2) Robust fallback: watch the cart AJAX endpoints directly. Any add/
  //    change/update/clear from any source (theme, quick-add, drawer, app)
  //    triggers a reconcile. Always returns the original fetch promise
  //    untouched so it can never break add-to-cart.
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var req = arguments[0];
        var url = (req && req.url) ? req.url : (typeof req === 'string' ? req : '');
        if (url && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          p.then(function () { scheduleReconcile(); }).catch(function () {});
        }
      } catch (e) { /* never interfere with the original request */ }
      return p;
    };
  }

  // 3) XHR fallback: some add-to-cart paths use XMLHttpRequest, not fetch.
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (url && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          this.addEventListener('loadend', function () { scheduleReconcile(); });
        }
      } catch (e) { /* never interfere */ }
      return origOpen.apply(this, arguments);
    };
  }

  // 4) Polling safety net: while the tab is visible, re-check every 3s.
  //    reconcile() is guarded (locked + state-change-only), so this mostly
  //    no-ops; it just guarantees the gift lands even if no event fired.
  setInterval(function () {
    if (document.visibilityState === 'visible') scheduleReconcile();
  }, 3000);

  // 5) Initial sweep on page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
